'use es6';

import { combineReducers } from 'redux';
import auth from './auth';
import appIntegrations from './appIntegrations';
import requestStates from './requestStates';
import notifications from 'ReduxMessenger/reducers/Notifications';
import trackingParams from './trackingParams';
import users from './users';
export default combineReducers({
  auth,
  appIntegrations,
  notifications,
  requestStates,
  trackingParams,
  users
});